var _a, _b, _c, _d, _e, _f, _g, _h, _j;
import { MarketTabsConstants, marketsRoute, viewInDetail, } from "../Common/constant";
export var MFCalculatorTabsEmum;
(function (MFCalculatorTabsEmum) {
    MFCalculatorTabsEmum["BY_INVESTMENT_AMOUNT"] = "BY_INVESTMENT_AMOUNT";
    MFCalculatorTabsEmum["BY_TARGET_AMOUNT"] = "BY_TARGET_AMOUNT";
})(MFCalculatorTabsEmum || (MFCalculatorTabsEmum = {}));
export var MFFundTypeEnum;
(function (MFFundTypeEnum) {
    MFFundTypeEnum[MFFundTypeEnum["EQUITY"] = 12] = "EQUITY";
    MFFundTypeEnum[MFFundTypeEnum["DEBT"] = 7] = "DEBT";
    MFFundTypeEnum[MFFundTypeEnum["HYBRID"] = 10] = "HYBRID";
})(MFFundTypeEnum || (MFFundTypeEnum = {}));
export var MFCalculatorInvestmentTypeEmum;
(function (MFCalculatorInvestmentTypeEmum) {
    MFCalculatorInvestmentTypeEmum["ONE_TIME_LUMPSUM"] = "ONE_TIME_LUMPSUM";
    MFCalculatorInvestmentTypeEmum["EVERY_MONTH_SIP"] = "EVERY_MONTH_SIP";
})(MFCalculatorInvestmentTypeEmum || (MFCalculatorInvestmentTypeEmum = {}));
export var MFCalculatorPeriodEnum;
(function (MFCalculatorPeriodEnum) {
    MFCalculatorPeriodEnum["ONE_YEAR"] = "1";
    MFCalculatorPeriodEnum["TWO_YEAR"] = "2";
    MFCalculatorPeriodEnum["THREE_YEAR"] = "3";
    MFCalculatorPeriodEnum["FOUR_YEAR"] = "4";
    MFCalculatorPeriodEnum["FIVE_YEAR"] = "5";
    MFCalculatorPeriodEnum["SIX_YEAR"] = "6";
    MFCalculatorPeriodEnum["SEVEN_YEAR"] = "7";
    MFCalculatorPeriodEnum["EIGHT_YEAR"] = "8";
    MFCalculatorPeriodEnum["NINE_YEAR"] = "9";
    MFCalculatorPeriodEnum["TEN_YEAR"] = "10";
    MFCalculatorPeriodEnum["ELEVEN_YEAR"] = "11";
    MFCalculatorPeriodEnum["TWELVE_YEAR"] = "12";
    MFCalculatorPeriodEnum["THIRTEEN_YEAR"] = "13";
    MFCalculatorPeriodEnum["FOURTEEN_YEAR"] = "14";
    MFCalculatorPeriodEnum["FIFTEEN_YEAR"] = "15";
    MFCalculatorPeriodEnum["SIXTEEN_YEAR"] = "16";
    MFCalculatorPeriodEnum["SEVENTEEN_YEAR"] = "17";
    MFCalculatorPeriodEnum["EIGHTEEN_YEAR"] = "18";
    MFCalculatorPeriodEnum["NINETEEN_YEAR"] = "19";
    MFCalculatorPeriodEnum["TWENTY_YEAR"] = "31";
})(MFCalculatorPeriodEnum || (MFCalculatorPeriodEnum = {}));
export var MFCalculatorReturnEnum;
(function (MFCalculatorReturnEnum) {
    MFCalculatorReturnEnum["ONE_PERCENT"] = "1";
    MFCalculatorReturnEnum["TWO_PERCENT"] = "2";
    MFCalculatorReturnEnum["THREE_PERCENT"] = "3";
    MFCalculatorReturnEnum["FOUR_PERCENT"] = "4";
    MFCalculatorReturnEnum["FIVE_PERCENT"] = "5";
    MFCalculatorReturnEnum["SIX_PERCENT"] = "6";
    MFCalculatorReturnEnum["SEVEN_PERCENT"] = "7";
    MFCalculatorReturnEnum["EIGHT_PERCENT"] = "8";
    MFCalculatorReturnEnum["NINE_PERCENT"] = "9";
    MFCalculatorReturnEnum["TEN_PERCENT"] = "10";
    MFCalculatorReturnEnum["ELEVEN_PERCENT"] = "11";
    MFCalculatorReturnEnum["TWELVE_PERCENT"] = "12.00";
    MFCalculatorReturnEnum["THIRTEEN_PERCENT"] = "12.50";
    MFCalculatorReturnEnum["FOURTEEN_PERCENT"] = "14";
    MFCalculatorReturnEnum["FIFTEEN_PERCENT"] = "15";
    MFCalculatorReturnEnum["SIXTEEN_PERCENT"] = "16";
    MFCalculatorReturnEnum["SEVENTEEN_PERCENT"] = "17";
    MFCalculatorReturnEnum["EIGHTEEN_PERCENT"] = "18";
    MFCalculatorReturnEnum["NINETEEN_PERCENT"] = "19";
    MFCalculatorReturnEnum["TWENTY_PERCENT"] = "20";
})(MFCalculatorReturnEnum || (MFCalculatorReturnEnum = {}));
export var MFCalculatorTabs = [
    {
        title: "By Investment amount",
        eventKey: MFCalculatorTabsEmum.BY_INVESTMENT_AMOUNT,
    },
    {
        title: "By Target amount",
        eventKey: MFCalculatorTabsEmum.BY_TARGET_AMOUNT,
    },
];
export var MFCalculatorInvestment = [
    {
        display: "One Time (Lumpsum)",
        value: MFCalculatorInvestmentTypeEmum.ONE_TIME_LUMPSUM,
    },
    {
        display: "Every Month (SIP)",
        value: MFCalculatorInvestmentTypeEmum.EVERY_MONTH_SIP,
    },
];
export var MFFundType = [
    (_a = {
            value: "Equity",
            display: "Equity",
            defaultValue: MFFundTypeEnum.EQUITY,
            max: 24,
            min: 8,
            jumpOff: 2
        },
        _a[MFCalculatorTabsEmum.BY_TARGET_AMOUNT] = (_b = {},
            _b[MFCalculatorInvestmentTypeEmum.ONE_TIME_LUMPSUM] = 15000000,
            _b[MFCalculatorInvestmentTypeEmum.EVERY_MONTH_SIP] = 30000000,
            _b),
        _a[MFCalculatorTabsEmum.BY_INVESTMENT_AMOUNT] = (_c = {},
            _c[MFCalculatorInvestmentTypeEmum.ONE_TIME_LUMPSUM] = 500000,
            _c[MFCalculatorInvestmentTypeEmum.EVERY_MONTH_SIP] = 10000,
            _c),
        _a),
    (_d = {
            value: "Debt",
            display: "Debt",
            defaultValue: MFFundTypeEnum.DEBT,
            max: 11,
            min: 3,
            jumpOff: 1
        },
        _d[MFCalculatorTabsEmum.BY_TARGET_AMOUNT] = (_e = {},
            _e[MFCalculatorInvestmentTypeEmum.ONE_TIME_LUMPSUM] = 15000000,
            _e[MFCalculatorInvestmentTypeEmum.EVERY_MONTH_SIP] = 30000000,
            _e),
        _d[MFCalculatorTabsEmum.BY_INVESTMENT_AMOUNT] = (_f = {},
            _f[MFCalculatorInvestmentTypeEmum.ONE_TIME_LUMPSUM] = 500000,
            _f[MFCalculatorInvestmentTypeEmum.EVERY_MONTH_SIP] = 10000,
            _f),
        _d),
    (_g = {
            value: "Hybrid",
            display: "Hybrid",
            defaultValue: MFFundTypeEnum.HYBRID,
            max: 14,
            min: 6,
            jumpOff: 1
        },
        _g[MFCalculatorTabsEmum.BY_TARGET_AMOUNT] = (_h = {},
            _h[MFCalculatorInvestmentTypeEmum.ONE_TIME_LUMPSUM] = 15000000,
            _h[MFCalculatorInvestmentTypeEmum.EVERY_MONTH_SIP] = 30000000,
            _h),
        _g[MFCalculatorTabsEmum.BY_INVESTMENT_AMOUNT] = (_j = {},
            _j[MFCalculatorInvestmentTypeEmum.ONE_TIME_LUMPSUM] = 500000,
            _j[MFCalculatorInvestmentTypeEmum.EVERY_MONTH_SIP] = 10000,
            _j),
        _g),
];
export var stepupWithTotalMaxPercent = 5;
export var expectedFDReturn = "7.00";
export var calculatorTimePeriod = {
    3: "3Y",
    5: "5Y",
    10: "10Y",
    15: "15Y",
    20: "20Y",
    // 25: "25Y",
    30: "30Y",
    // 35: "35Y",
    40: "40Y",
};
export var calculatorAssuredReturns = {
    6: "6",
    8: "8",
    10: "10",
    12: "12",
    14: "14",
    16: "16",
    18: "18",
    20: "20",
    22: "22",
};
export var calculatorAssuredReturnsMarks = function (min, max, jumpoff) {
    var marks = {};
    for (var i = min; i <= max; i = i + jumpoff) {
        marks["".concat(i)] = i.toString();
    }
    return marks;
};
export var calculatorBlurEffectEnum;
(function (calculatorBlurEffectEnum) {
    calculatorBlurEffectEnum["CALCULATOR"] = "calculator";
    calculatorBlurEffectEnum["RESULT"] = "result";
})(calculatorBlurEffectEnum || (calculatorBlurEffectEnum = {}));
export var MutualFundsNavigation = [
    {
        category: "Top Performing Funds ",
        key: "TopPerformingFunds",
    },
    {
        category: "Sector Based Funds",
        key: "SectorBasedFunds",
    },
    {
        category: "Ideas for Investment",
        key: "IdeasforInvestment",
    },
    {
        category: "Explore All Funds",
        key: "ExploreAllFunds",
    },
    {
        category: "Index Based Funds",
        key: "IndexBasedFunds",
    },
    {
        category: "Tips for Investment",
        key: "TipsForInvesting",
    },
];
export var mfRouteConstant = {
    mktmf: marketsRoute.markets + "/" + MarketTabsConstants.MutualFunds,
};
export var mfViewallRouteConstant = {
    mfViewall: mfRouteConstant.mktmf + viewInDetail.viewall,
};
export var MFRoutes = {
    topPerformingViewAll: mfViewallRouteConstant.mfViewall + "/:section/:subSection",
    exploreFunds: mfViewallRouteConstant.mfViewall + "/explore-funds",
};
export var B_MFRoutes = {
    topPerformingFunds: mfViewallRouteConstant.mfViewall + "/top-performing",
    ideaForInvestment: mfViewallRouteConstant.mfViewall + "/idea-for-investment",
    sectorFunds: mfViewallRouteConstant.mfViewall + "/sector",
    indexFunds: mfViewallRouteConstant.mfViewall + "/index",
    exploreFunds: mfViewallRouteConstant.mfViewall + "/explore-funds",
};
export var MfRoutes = [
    { title: "Top Performing Funds", link: B_MFRoutes.topPerformingFunds },
    { title: "Idea For Investment", link: B_MFRoutes.ideaForInvestment },
    { title: "Sector Funds", link: B_MFRoutes.sectorFunds },
    { title: "Index Funds", link: B_MFRoutes.indexFunds },
    { title: "Explore All Funds", link: B_MFRoutes.exploreFunds },
];
